import React from 'react'

export function useToggle(initialState = false): [boolean, () => void] {
	const [state, setState] = React.useState(initialState)
	const toggle = React.useCallback(() => setState((prevState) => !prevState), [])
	return [state, toggle]
}
